import { useEffect } from "react";
import { useLikesQuery } from "@/common/queries/queries";
import { useLikesStore } from "../../../../common/store/likesStore";

export const useLikesData = () => {
  const setLikes = useLikesStore((state) => state.setLikes);
  const likes = useLikesStore((state) => state.likes);

  const { data } = useLikesQuery();

  useEffect(() => {
    if (data && !likes.length) {
      setLikes(data);
    }
  }, [data]);

  return { likes };
};
